(function () {
  if (!document.body.classList.contains('template-product')) return;

  document.addEventListener('click', function (event) {
    if (event.target.closest('.js-photoswipe__zoom')) return;

    var imageMain = event.target.closest('.product-image-main');
    if (!imageMain) return;

    var zoom = imageMain.querySelector('.js-photoswipe__zoom');
    if (!zoom) return;

    zoom.click();
  });
})();
